<label [for]="id" class="flex items-center gap-2.5 cursor-pointer group select-none">
    <div class="relative flex items-center shrink-0">
        <input type="checkbox" [id]="id" [checked]="value" [disabled]="disabled" (change)="onToggle()"
            [ngClass]="[boxSizeClasses, shapeClass]"
            class="peer border-2 border-foreground/15 dark:border-white/10 text-primary transition-all cursor-pointer appearance-none checked:bg-primary checked:border-primary disabled:opacity-30 disabled:cursor-not-allowed" />
        <!-- Checkmark icon -->
        <svg [ngClass]="checkSizeClasses" class="absolute text-white pointer-events-none hidden peer-checked:block"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
    </div>
    <span *ngIf="label" [ngClass]="labelSizeClasses"
        class="font-black uppercase tracking-widest text-text-muted group-hover:text-foreground transition-colors">
        {{ label }}
    </span>
</label>